import styled from 'styled-components';

import { Loader } from './loader';
import { Layout } from '../layout';

export const PageLoader = () => {
  return (
    <Layout title="Loading...">
      <Content>
        <Loader bgColor="#f0f4f7" />
      </Content>
    </Layout>
  );
};

const Content = styled.div`
  display: flex;
  min-height: 184px;
`;
